import { handlePayment } from './handler';
import { getStripeInstance } from './utilities';

function renderPaymentElement() {
	const checkoutForms = document.querySelectorAll('[checkout-form]');
	checkoutForms.forEach((form) => {
		const clientSecret = form.querySelector('input[name="client_secret"]')?.value;
		const paymentAmount = Number(form.querySelector('input[name="payment_amount"]')?.value || 0);
		const paymentCurrency = (form.querySelector('input[name="payment_currency"]')?.value || '').toLowerCase();
		const hasDeferredAmount = Number.isFinite(paymentAmount) && paymentAmount > 0 && !!paymentCurrency;
		if (!clientSecret && !hasDeferredAmount) return;

		const stripe = getStripeInstance();
		if (!stripe) return;

		const appearance = {
			theme: 'stripe',
			variables: {
				colorPrimary: '#ECB95D',
				fontSizeBase: '16px',
			},
			rules: {
				'.Input': {
					padding: '12px 16px',
					marginBottom: '4px',
				},
				'.Tab': {
					margin: '0px 8px',
					padding: '16px',
				},
				'.Label': {
					fontSize: 'var(--fontSizeBase)',
					marginBottom: '10px',
					fontWeight: '500',
				}
			}
		};

		const elementOptions = hasDeferredAmount
			? {
				mode: 'payment',
				amount: paymentAmount,
				currency: paymentCurrency,
				appearance,
				paymentMethodCreation: 'manual',
			}
			: {
				clientSecret,
				appearance,
				paymentMethodCreation: 'manual',
			};

		const elements = stripe.elements(elementOptions);
		const paymentElement = elements.create('payment', {
			layout: 'tabs'
		});

		paymentElement.mount('#payment-elements');
		handlePayment(stripe, elements);
	});
}

export function initRender() {
	renderPaymentElement();
}
